module.exports = __webpack_public_path__ + "static/media/toss.2305efc1.png";